function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#009AD7",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M356.875 103.922c27.761-10.39 41.815-41.317 31.363-69.109C377.849 7.082 346.901-6.971 319.17 3.429c-27.751 10.42-41.785 41.347-31.394 69.108C298.186 100.299 329.134 114.363 356.875 103.922z"
}), React.createElement("path", {
  d: "M395.769 311.136V167.261c-.367-21.798-18.358-39.159-40.156-38.772-21.808.376-39.201 18.328-38.824 40.136v129.761l-85.29 15.57c-18.236 3.094-32.911 15.845-33.002 35.232l2.595 129.984c-.05 15.142 12.192 27.517 27.386 27.6 15.173.02 27.538-12.212 27.598-27.395l7.988-102.05h73.475C378.795 377.222 395.891 352.372 395.769 311.136z"
}), React.createElement("path", {
  d: "M461.529 233.388c-11.245-2.412-22.306 4.792-24.698 16.058l-22.204 104.605c-1.71 7.367-3.918 13.199-6.402 17.758-3.837 6.818-7.918 10.888-14.054 14.38-6.117 3.398-14.888 5.984-27.284 6.95-3.277.274-6.778.468-10.523.498h-58.758c-11.52.183-20.668 9.739-20.476 21.249.194 11.51 9.688 20.668 21.208 20.485h58.453c4.601-.041 9.078-.336 13.403-.662 10.98-.895 21.136-2.778 30.601-6.054 14.166-4.844 26.683-13.22 35.842-24.658 9.24-11.388 15.01-25.167 18.592-40.493l.062-.244 22.306-105.174C479.99 246.82 472.795 235.748 461.529 233.388z"
}), React.createElement("path", {
  d: "M209.356 225.735V195.897H101.505L61.674 95.679 33.943 106.69 81.264 225.735z"
}), React.createElement("path", {
  d: "M251.039 240.369H35.673v11.112v30.53V512h38.213V282.011H251.039z"
}));

var SvgEnvironment = function SvgEnvironment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgEnvironment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Environment.70a858ca.svg";
export { ForwardRef as ReactComponent };